import React, { useState } from "react";
import styles from "./PaymentModule.module.css";
import { Add, PlusOne, Refresh } from "@mui/icons-material";

const VendorPaymentModule = () => {
  const [paymentMode, setPaymentMode] = useState("Cash");
  const [amount, setAmount] = useState(0);
  const [description, setDescription] = useState("");
  const [gstChecked, setGstChecked] = useState(false);
  const [tdsChecked, setTdsChecked] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.paymentSection}>
        <div className={styles.header}>
          <label style={{ display: "flex", gap: "15px", color: "#fff" }}>
            <input type="radio" name="type" /> Paid
          </label>
          <label style={{ display: "flex", gap: "15px", color: "#fff" }}>
            <input type="radio" name="type" defaultChecked /> Received
          </label>
          <label style={{ display: "flex", gap: "15px", color: "#fff" }}>
            <input type="radio" name="type" /> Advance
          </label>
        </div>
        <div className={styles["form-c"]}>
          <div className={styles.formGroup}>
            <label>Payment Mode</label>
            <select
              value={paymentMode}
              onChange={(e) => setPaymentMode(e.target.value)}
              className={styles["summary-select"]}
              
            >
              <option value="Cash">Cash</option>
              <option value="Bank">Bank</option>
              <option value="Card">Card</option>
            </select>
          </div>
          <div className={styles.formGroup}>
            <label>Amount</label>
            <input
            style={{width: '100%', height: '33px'}}
            className={styles["summary-input"]}
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
          <div className={styles.formGroup}>
            <label>Description</label>
            <input
             style={{width: '100%', height: '33px'}}
           className={styles["summary-input"]}

              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div style={{display: 'flex', gap: '10px', marginTop: '28px'}}>
            <Add
              //  onClick={paymentMode}
              type="button"
              style={{
                cursor: "pointer",
                fontSize: "30px",
                background: "#0077d4",
                color: "white",
                border: "1px solid #0077d4",
                borderRadius: "20%",
              }}
            />
            <Refresh
              //  onClick={handleReset}
              type="button"
              style={{
                cursor: "pointer",
                fontSize: "30px",
                background: "white",
                color: "#0077d4",
                border: "1px solid #0077d4",
                borderRadius: "20%",
              }}
            />
          </div>
        </div>

        <table className={styles.paymentTable}>
          <thead>
            <tr className={styles["table-header-row"]}>
              <th style={{fontSize: '12px', padding: '2px', backgroundColor: '#627282', color: '#fff'}}>Sr No</th>
              <th style={{fontSize: '12px', padding: '2px', backgroundColor: '#627282', color: '#fff'}}>Mode</th>
              <th style={{fontSize: '12px', padding: '2px', backgroundColor: '#627282', color: '#fff'}}>Amount</th>
              <th style={{fontSize: '12px', padding: '2px', backgroundColor: '#627282', color: '#fff'}}>Gold</th>
              <th style={{fontSize: '12px', padding: '2px', backgroundColor: '#627282', color: '#fff'}}>Silver</th>
              <th style={{fontSize: '12px', padding: '2px', backgroundColor: '#627282', color: '#fff'}}>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="6">No Payments Added</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.summarySection}>
        <div className={styles.summaryLeft}>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>Fine Metal</label>
            <input type="text" className={styles.summaryInput} />
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>Paid Metal</label>
            <input type="text" className={styles.summaryInput} />
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>Balance Metal</label>
            <input type="text" className={styles.summaryInput} />
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>Advance  Metal</label>
            <input type="text" className={styles.summaryInput} />
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>Courier  Metal</label>
            <input type="text" className={styles.summaryInput} />
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>Paid Amount</label>
            <input type="text" className={styles.summaryInput}/>
          </div>
        </div>
        <div className={styles.summaryRight}>
        <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>Taxable Amount</label>
            <input type="text"className={styles.summaryInput}/>
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>GST(3%)</label>
            <input type="checkbox" style={{width: '48px', height: '15px'}}/>
            <input type="text" className={styles.summaryInput}/>
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>TDS(0.1%)</label>
            <input type="text" className={styles.summaryInput}/>
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>R.O./Discount(-)</label>
            <input type="text" className={styles.summaryInput} />
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>Total Amount</label>
            <input type="text"className={styles.summaryInput} />
          </div>
          <div className={styles.summaryLeftField}>
            <label htmlFor="" style={{fontWeight: 'bold'}}>Balance Amount</label>
            <input type="text" className={styles.summaryInput} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorPaymentModule;
